module.exports = __webpack_public_path__ + "static/img_2355-39c615fd0d4483015fbd7a924a7de601.webp";